import React from "react"
import Loadable from "@loadable/component"
import Navbar from "../components/App/Navbar"
import Layout from "../components/App/Layout"
import MainBanner from "../components/MachineLearningAISolutions/MainBanner"
const Services = Loadable(() =>
  import("../components/DigitalMarketingAgency/Services")
)
const OurFeatures = Loadable(() => import("../components/Index/OurFeatures"))
const RecentProjects = Loadable(() =>
  import("../components/Index/RecentProjects")
)
const Partner = Loadable(() => import("../components/Index/Partner"))
const Chooseus = Loadable(() => import("../components/Index/Chooseus"))
const StartProjectTwo = Loadable(() =>
  import("../components/Common/StartProjectTwo")
)
const Footer = Loadable(() => import("../components/App/Footer"))
const TestimonialSection = Loadable(() =>
  import("../components/TestimonialComponent")
)
const FunFactsSection = Loadable(() =>
  import("../components/DynamicPages/FunfactComponent")
)

const DeferredSection = ({ children, minHeight = 0 }) => {
  const [shouldRender, setShouldRender] = React.useState(false)
  const containerRef = React.useRef(null)

  React.useEffect(() => {
    const node = containerRef.current
    if (!node || shouldRender) return undefined

    if (typeof window === "undefined" || !("IntersectionObserver" in window)) {
      setShouldRender(true)
      return undefined
    }

    const observer = new window.IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            setShouldRender(true)
            observer.disconnect()
          }
        })
      },
      { rootMargin: "500px 0px" }
    )

    observer.observe(node)

    return () => observer.disconnect()
  }, [shouldRender])

  return (
    <div ref={containerRef} style={minHeight ? { minHeight } : undefined}>
      {shouldRender ? children : null}
    </div>
  )
}

const Home = () => {
  return (
    <Layout>
      <Navbar />
      <MainBanner />
      <DeferredSection minHeight={1100}>
        <Services />
      </DeferredSection>
      <DeferredSection minHeight={500}>
        <OurFeatures />
      </DeferredSection>
      <DeferredSection minHeight={900}>
        <RecentProjects />
      </DeferredSection>
      <DeferredSection minHeight={220}>
        <Partner />
      </DeferredSection>
      <DeferredSection minHeight={520}>
        <TestimonialSection />
      </DeferredSection>
      <DeferredSection minHeight={680}>
        <Chooseus />
      </DeferredSection>
      <DeferredSection minHeight={140}>
        <FunFactsSection />
      </DeferredSection>
      <DeferredSection minHeight={270}>
        <StartProjectTwo />
      </DeferredSection>
      <Footer />
    </Layout>
  )
}

export default Home
